import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { Authentication } from '../Components/Organisms/Authentication/Authentication'
import { RouteGuard } from '../Guards/RouteGuard'
import { useDisableUserInfoErrors } from '../../React/Common/Hooks/useDisableUserInfoErrors'

@Route(RouteID.AUTH)
export class Authenticate extends Component {
    render(): ReactElement {
        useDisableUserInfoErrors()

        return (
            <RouteGuard route={RouteID.AUTH}>
                <Authentication />
            </RouteGuard>
        )
    }
}
